import React, { lazy, useEffect } from 'react'
import IconShare from '../../assets/icons/icon-blue-share.svg'
import SkeletonLoading from '../common/SkeletonLoading'
import { Suspense, useState } from 'react'
import ShareModal from '../ShareModal'
import { isValidStr } from '../../common_functions'
import enterpriseApi from '../../store/reducers/enterprise/enterpriseApi'
import { DORMITORY, PARKING_SPACES, ROOMS } from '../../constants/enterpriseSpecificationsTypes'
import { CategoryEnterprise } from '../CategoryEnterprise'
import statusApi from '../../store/reducers/status/statusApi'
import FavoriteEnterprise from '../FavoriteEnterprise'
import FavoriteEnterpriseCircle from '../FavoriteEnterpriseCircle'
import { EnterpriseData } from '../../interfaces/enterprise/enterpriseData'
import BaseInfos from './BaseInfos'
import CardPatrocinadoByIndex from '../Cards/CardPatrocinadoByIndex'

interface Props {
  enterprise: EnterpriseData
}

const Error = lazy(() => import('../Error'))

export default function Header({ enterprise }: Props) {
  const [openShareModal, setOpenShareModal] = useState(false)
  const [parkingSpaces, setParkingSpaces] = useState(0)
  const [rooms, setRooms] = useState<number[]>([])
  const [categoryStatusEnterprise, setCategoryStatusEnterprise] = useState('')

  const { data, isError, isLoading, isSuccess, status, error } =
    enterpriseApi.useGetEnterpriseAddressByIdQuery(enterprise.Id ?? '')

  const [
    useStatus,
    {
      data: dataStatusAll,
      isError: isErrorStatusAll,
      isLoading: isLoadingStatusAll,
      isSuccess: isSuccessStatusAll
    }
  ] = statusApi.useGetStatusAllMutation()

  const {
    data: dataTipologies,
    isError: isErrorTipologies,
    isLoading: isLoadingTipologies,
    isSuccess: isSuccessTipologies,
    status: statusTipologies,
    error: errorTipologies
  } = enterpriseApi.useGetEnterpriseTipologiesByIdQuery(enterprise.Id ?? '')

  const {
    data: dataInfo,
    isError: isErrorInfo,
    isLoading: isLoadingInfo,
    isSuccess: isSuccessInfo,
    status: statusInfo,
    error: errorInfo
  } = enterpriseApi.useGetEnterpriseInformationByIdQuery(enterprise.Id ?? '')

  const handleShareModal = () => {
    setOpenShareModal(!openShareModal)
  }

  useEffect(() => {
    if (isSuccessTipologies) getTipologies()
  }, [isSuccessTipologies])

  useEffect(() => {
    getStatusAll()
  }, [enterprise.StatusId])

  useEffect(() => {
    if (isSuccessStatusAll) {
      setCategoryStatusEnterprise(
        dataStatusAll?.Data.filter((x) => x.Id == enterprise.StatusId)[0].Name ?? ''
      )
    }
  }, [isSuccessStatusAll])

  const getStatusAll = async () => {
    await useStatus(undefined)
  }

  const getTipologies = () => {
    var list: number[] = []
    if (dataTipologies != undefined && dataTipologies.Data.length > 0) {
      dataTipologies?.Data.forEach((element) => {
        if (element.Specification.Type === PARKING_SPACES) {
          setParkingSpaces(element.Specification.Quantity)
        }
        if (element.Specification.Type === DORMITORY || element.Specification.Type === ROOMS) {
          list.push(element.Specification.Quantity)
        }
      })
    }

    list = [...new Set(list)]
    list.sort()
    setRooms(list)
  }

  const getTotalArea = () => {
    if (isSuccessInfo) {
      if (parseInt(dataInfo?.Data.TotalArea)) {
        return `${parseInt(dataInfo?.Data.TotalArea)}m²`
      } else {
        return dataInfo?.Data.TotalArea
      }
    }
    return ''
  }

  return (
    <div>
      {(isLoadingInfo || isLoadingTipologies) && <SkeletonLoading height={300} />}
      {isSuccessInfo && isSuccessTipologies && (
        <>
          <div className="flex m-auto w-fit gap-3">
            <div className="group-actions gap-2 w-[50px] m-auto lg:mr-0">
              <ShareModal
                url={location.href}
                title={`Veja esse empreendimento ${
                  isValidStr(enterprise.Title) ? ' - ' + enterprise.Title : ''
                }:`}
                isOpen={openShareModal}
                onClose={handleShareModal}
              />
              <div className="">
                <a href="#">
                  <div
                    className="border border-gray-200 content-center rounded-full w-[48px] h-[48px] text-center cursor-pointer"
                    onClick={handleShareModal}
                  >
                    <Suspense fallback={<SkeletonLoading />}>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        className="inline-block"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.9966 16.1582C16.4425 16.1582 15.9311 16.3495 15.5305 16.669L11.5016 13.801C11.5691 13.4367 11.5691 13.0633 11.5016 12.699L15.5305 9.83099C15.9311 10.1505 16.4425 10.3418 16.9966 10.3418C18.2838 10.3418 19.33 9.3125 19.33 8.04592C19.33 6.77934 18.2838 5.75 16.9966 5.75C15.7094 5.75 14.6633 6.77934 14.6633 8.04592C14.6633 8.26786 14.6944 8.48023 14.7547 8.68304L10.928 11.4094C10.3602 10.669 9.45801 10.1888 8.44107 10.1888C6.72218 10.1888 5.32996 11.5587 5.32996 13.25C5.32996 14.9413 6.72218 16.3112 8.44107 16.3112C9.45801 16.3112 10.3602 15.831 10.928 15.0906L14.7547 17.817C14.6944 18.0198 14.6633 18.2341 14.6633 18.4541C14.6633 19.7207 15.7094 20.75 16.9966 20.75C18.2838 20.75 19.33 19.7207 19.33 18.4541C19.33 17.1875 18.2838 16.1582 16.9966 16.1582ZM16.9966 7.05102C17.5547 7.05102 18.0077 7.49681 18.0077 8.04592C18.0077 8.59503 17.5547 9.04082 16.9966 9.04082C16.4386 9.04082 15.9855 8.59503 15.9855 8.04592C15.9855 7.49681 16.4386 7.05102 16.9966 7.05102ZM8.44107 14.9337C7.49801 14.9337 6.72996 14.1779 6.72996 13.25C6.72996 12.3221 7.49801 11.5663 8.44107 11.5663C9.38412 11.5663 10.1522 12.3221 10.1522 13.25C10.1522 14.1779 9.38412 14.9337 8.44107 14.9337ZM16.9966 19.449C16.4386 19.449 15.9855 19.0032 15.9855 18.4541C15.9855 17.905 16.4386 17.4592 16.9966 17.4592C17.5547 17.4592 18.0077 17.905 18.0077 18.4541C18.0077 19.0032 17.5547 19.449 16.9966 19.449Z"
                          fill="#0059FF"
                        />
                      </svg>
                    </Suspense>
                  </div>
                </a>
              </div>
            </div>
            <div className="w-fit max-w-full">
              <div className="min-w-[50px] m-auto float-right">
                <FavoriteEnterpriseCircle enterpriseId={enterprise.Id ?? ''} />
              </div>
            </div>
          </div>

          <h1 className="text-3xl lg:text-[50px] leading-[48px] font-bold mt-2 lg:mt-5">
            {enterprise.Title}
          </h1>
          <hr className="opacity-20 my-3" />
          <p className="text-lg lg:text-xl text-[#52525B] fw-normal -z-[1]" style={{ position: 'relative' }}>
            <span className="">
              {/* <MapPin weight="fill" className="inline-block" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                className="inline-block"
              >
                <path
                  d="M9.99992 9.99935C9.08325 9.99935 8.33325 9.24935 8.33325 8.33268C8.33325 7.41602 9.08325 6.66602 9.99992 6.66602C10.9166 6.66602 11.6666 7.41602 11.6666 8.33268C11.6666 9.24935 10.9166 9.99935 9.99992 9.99935ZM14.9999 8.49935C14.9999 5.47435 12.7916 3.33268 9.99992 3.33268C7.20825 3.33268 4.99992 5.47435 4.99992 8.49935C4.99992 10.4493 6.62492 13.0327 9.99992 16.116C13.3749 13.0327 14.9999 10.4493 14.9999 8.49935ZM9.99992 1.66602C13.4999 1.66602 16.6666 4.34935 16.6666 8.49935C16.6666 11.266 14.4416 14.541 9.99992 18.3327C5.55825 14.541 3.33325 11.266 3.33325 8.49935C3.33325 4.34935 6.49992 1.66602 9.99992 1.66602Z"
                  fill="black"
                  fill-opacity="0.45"
                />
              </svg>
            </span>{' '}
            Localização privilegiada em
            <h2 className="fw-bold opacity-90 mt-2 text-[#1F1E1E]">{data?.Data.Location}</h2>
          </p>
          <hr className="opacity-20 my-3" />
          <BaseInfos
            Id={enterprise.Id}
            Description={enterprise.Description}
            StatusId={enterprise.StatusId}
            ConstructionCompanyId={enterprise.ConstructionCompanyId}
          />
          <div className='mt-3'>
            <CardPatrocinadoByIndex
              position={1}
              enterpriseId={enterprise.Id}
              constructionCompanyId={enterprise.ConstructionCompanyId}
            />
          </div>
        </>
      )}
    </div>
  )
}
